import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';
import './WrappedFormIncrementalStepper.css';

function WrappedIncrementalFormStepper(props) {
  const { input: { onChange, value }, formatValue, parseValue } = props;

  const cleanProps = _.omit(props, ['formatValue', 'parseValue']);

  return (
    <NumericInput
      mobile
      value={value}
      format={formatValue}
      parse={parseValue}
      onChange={onChange}
      size={4}
      className="form-incremental-stepper"
      noStyle
      {...cleanProps}
    />
  );
}

WrappedIncrementalFormStepper.propTypes = {
  formatValue: PropTypes.func.isRequired,
  parseValue: PropTypes.func.isRequired,
  // input prop is provided by redux-form
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired
};

export default WrappedIncrementalFormStepper;



// WEBPACK FOOTER //
// ./src/components/form/WrappedFormIncrementalStepper.js